export type ProductTitleSizeClass = '' | 'h1-sm' | 'h1-xs';

/** Heading the server rendered into the page shell (DF4 `product.cshtml`): `{"h1": "..."}` on a default opening, `null` otherwise. */
declare var __preload_header: {h1?: string} | null | undefined;

/** Pick h1 size class from the exact text shown in the product heading. */
export function getProductTitleSizeClass(headingText: string): ProductTitleSizeClass {
    const len = headingText.length;
    if (len > 100) return 'h1-xs';
    if (len > 70) return 'h1-sm';
    return '';
}

/**
 * The server's heading text, so the app's H1 shows exactly what the shell showed before the app mounted.
 * Null when the global is missing (unit tests, pages that do not emit it), is null (not a default opening) or has no
 * non-blank `h1`; the caller then composes the heading itself.
 */
export function readPreloadHeading(): string | null {
    const preload = typeof __preload_header !== 'undefined' ? __preload_header : null;
    const h1 = preload?.h1;
    return typeof h1 === 'string' && h1.trim() !== '' ? h1 : null;
}
